import { HTMLAttributes, forwardRef } from 'react'
import { clsx } from 'clsx'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'outlined' | 'elevated'
  padding?: 'sm' | 'md' | 'lg'
}

// Touch-optimized card component for Galaxy Tab Active5
// Nordic Industrial palette
const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, variant = 'elevated', padding = 'lg', className, ...props }, ref) => {
    const variants = {
      default: 'bg-white',
      outlined: 'bg-white border border-slate-200',
      elevated: 'bg-white shadow-sm border border-slate-200',
    }
    
    const paddings = {
      sm: 'p-4',
      md: 'p-6',
      lg: 'p-8',
    }
    
    return (
      <div
        ref={ref}
        className={clsx(
          'rounded-lg',
          variants[variant],
          paddings[padding],
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'

export default Card

